import { render, staticRenderFns } from "./DynPropIntDetail.vue?vue&type=template&id=94e1e5ba"
import script from "./DynPropIntDetail.vue?vue&type=script&lang=js"
export * from "./DynPropIntDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports